import React, { Fragment } from 'react';
import { Form, Grid } from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';

import { VIRGINIA_CLAIM_REPORT_FORM_NAME } from 'Common/FormEnum';

import { TitledCard } from 'Components/';
import { VirginiaClaimReportFieldEnum as Fields } from 'Common/FieldEnum';
import { DatePickerField, CheckboxField } from 'Common/SemanticWrapper';
import { MONTH_YEAR_DATE_FORMAT } from 'Common/Constants';
import SelectSitesTable from 'Common/SelectSitesTableReduxForm';

function VirginiaClaimReportFormContainer() {
  const MaxDate = moment();
  return (
    <Fragment>
      <Form name={VIRGINIA_CLAIM_REPORT_FORM_NAME}>
        <TitledCard title={''}>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name={Fields.MonthYear}
                  component={DatePickerField}
                  dateFormat={MONTH_YEAR_DATE_FORMAT}
                  maxDate={MaxDate}
                  label="Date"
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  label={'Print Original Values'}
                  name={Fields.PrintOriginalValues}
                  component={CheckboxField}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column className="field">
                <label className={'p-b-0'}>Sites</label>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field name={Fields.Sites} component={SelectSitesTable} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    </Fragment>
  );
}

const validate = (values) => {
  let errors = {};

  if (!values[Fields.Sites] || !values[Fields.Sites].length) {
    errors[Fields.Sites] = 'At least one site must be selected.';
  }

  if (!moment(values[Fields.MonthYear], MONTH_YEAR_DATE_FORMAT).isValid()) {
    errors[Fields.MonthYear] = 'A valid date must be selected.';
  }

  return errors;
};

export default reduxForm({
  form: VIRGINIA_CLAIM_REPORT_FORM_NAME,
  validate,
  enableReinitialize: true,
})(withRouter(VirginiaClaimReportFormContainer));



// WEBPACK FOOTER //
// ./src/pages/virginiaclaimreport/components/VirginiaClaimReportForm.js